import React from "react";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import { Box } from "@mui/material";
export const Animation_Warning_animation = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        //Color amarillo suave
        backgroundColor: "#FFF9E6",
        border: "3px solid #FDE68A",
        borderRadius: "50%",
        padding: "20px",
      }}
    >
      {/* Fondo de icono blanco */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80px",
          width: "80px",
          backgroundColor: "#FFFFFF",
          borderRadius: "50%",
        }}
      >
        <ErrorOutlineRoundedIcon sx={{ fontSize: 100, color: "#F59E0B" }} />
      </Box>
    </Box>
  );
};

export default Animation_Warning_animation;
